import React, { FC } from 'react';
import { View } from 'react-native';

import { DailyHourlyForecastTileDetail } from '@constants';
import { helpers } from '@helpers';
import { IconCode } from '@types';

import { WeatherTileDetailTestIds } from './constants';
import { styles } from './styles';

import { TWCIcon } from '../../primitives/TWCIcon/TWCIcon';
import { TWCText } from '../../primitives/TWCText/TWCText';

export type WeatherTileDetailProps = {
  data?: {
    iconCodeExtend?: IconCode;
    nightTemperature?: string;
    temperature?: string;
    title?: string;
    precipChance?: string;
  };
  testID?: string;
  error?: unknown;
};

export const WeatherTileDetail: FC<WeatherTileDetailProps> = ({ data = {}, error, testID }) => (
  <View style={styles.background} testID={testID}>
    <View style={styles.dataLayout}>
      <TWCText testID={DailyHourlyForecastTileDetail.detailTitle} variant="mediumText24">
        {helpers.displayString(data?.title, error)}
      </TWCText>
      <View style={styles.iconWrapper} testID={WeatherTileDetailTestIds.iconWrapper}>
        {error || !data.iconCodeExtend ? (
          <TWCText noTestID variant="mediumText54">
            {'—'}
          </TWCText>
        ) : (
          <TWCIcon code={data?.iconCodeExtend} type="forecast" />
        )}
      </View>

      <View style={styles.tempPrecipWrapper}>
        <TWCText testID={DailyHourlyForecastTileDetail.detailTemperature} variant="mediumText36">
          {helpers.displayString(data?.temperature, error)}
        </TWCText>
        <View style={styles.spacer} />
        {data?.precipChance ? (
          <TWCText style={styles.precipText} testID={DailyHourlyForecastTileDetail.detailPrecip} variant="mediumText24">
            {error ? null : helpers.displayString(data?.precipChance)}
          </TWCText>
        ) : (
          <TWCText
            style={styles.precipText}
            testID={DailyHourlyForecastTileDetail.detailNightTemperature}
            variant="mediumText24"
          >
            {error ? null : helpers.displayString(data?.nightTemperature)}
          </TWCText>
        )}
      </View>
    </View>
  </View>
);
